module.exports = __webpack_public_path__ + "img/Kimberley-Clark_1.d2f50a25.jpg";